<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Driver Checks</h2>
    </div>
    <br />

    <div class="row content-block">
      <div class="col">
        <app-tabs (tabClicked)='this.cancelAllCheck()'>
          @for (vehicleType of this.vehicleChecks; track vehicleType; let t = $index) {
            <app-tab
              title='{{vehicleType.name}} ({{vehicleType.checks.length}})'
              >
              <table class='table table-bordered table-hover' >
                <thead class='thead-light'>
                  <tr>
                    <th>Question</th>
                    <th>Severity</th>
                    <th>Check Area</th>
                    <th>VOR?</th>
                    <th>Active?</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (checks of vehicleType.checks; track checks; let c = $index) {
                    <tr>
                      @if (!checks.editing) {
                        <td>{{checks.checkInformation}}</td>
                        <td>{{this.getSeverity(checks.severity)}}</td>
                        <td>{{this.getArea(checks.vehicleCheckAreaId)}}</td>
                        <td>{{this.parseBoolean(checks.isVor)}}</td>
                        <td>{{this.parseBoolean(checks.active)}}</td>
                        <td class='p-0 text-center'>
                          @if (!disableButtons) {
                            <button
                              class='btn btn-warning m-0 btn-block'
                              (click)='this.editCheck(vehicleType.vehicleTypeId,checks.id)'>
                              <i class="far fa-edit"></i>
                            </button>
                          }
                          @if (disableButtons) {
                            <button disabled class='btn btn-warning m-0 btn-block'><i class="far fa-edit"></i></button>
                          }
                        </td>
                      }
                      @if (checks.editing) {
                        <td>
                          <input class='form-control' type='text' placeholder='Question...' [(ngModel)]='checks.checkInformation'/>
                        </td>
                        <td>
                          <select class='form-control' (change)='checks.severity=+$event.target.value;'>
                            @for (item of this.severities; track item) {
                              <option [selected]='checks.severity === item.severity' [value]='item.severity'>{{ item.severity }} - {{item.notes}}</option>
                            }
                          </select>
                        </td>
                        <td>
                          <select class='form-control' (change)='checks.vehicleCheckAreaId=+$event.target.value;'>
                            @for (item of this.checkAreas; track item) {
                              <option [selected]='item.id === checks.vehicleCheckAreaId' [value]='item.id'>{{ item.name }}</option>
                            }
                          </select>
                        </td>
                        <td>
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" [id]="'vor-' + t + '-' + c" [(ngModel)]='checks.isVor'>
                            @if (checks.isVor) {
                              <label class="custom-control-label" [attr.for]="'vor-' + t + '-' + c">Failure triggers VOR</label>
                            }
                            @if (!checks.isVor) {
                              <label class="custom-control-label" [attr.for]="'vor-' + t + '-' + c">Failure is not VOR</label>
                            }
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" [id]="'active-' + t + '-' + c" [(ngModel)]='checks.active'>
                            @if (checks.active) {
                              <label class="custom-control-label" [attr.for]="'active-' + t + '-' + c">Shows in App</label>
                            }
                            @if (!checks.active) {
                              <label class="custom-control-label" [attr.for]="'active-' + t + '-' + c">Hidden in App</label>
                            }
                          </div>
                        </td>
                        <td class='p-0 text-center'>
                          <div class="btn-group m-0 p-0">
                            <button
                              class='btn btn-success'
                              (click)='this.updateCheck(checks)'>
                              <i class="fas fa-check"></i>
                            </button>
                            <button
                              class='btn btn-danger'
                              (click)='this.cancelEditCheck(vehicleType.vehicleTypeId,checks.id)'>
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </td>
                      }
                    </tr>
                  }
                  @if (vehicleType.addToggle) {
                    <tr>
                      <td>
                        <input class='form-control' type='text' placeholder='Question...' [(ngModel)]='this.newCheck.checkInformation'/>
                      </td>
                      <td>
                        <select class='form-control' (change)='this.changeVehicleSeverity($event)'>
                          <option value='-1'>Select Severity</option>
                          @for (item of this.severities; track item) {
                            <option [value]='item.severity'>{{ item.severity }} - {{item.notes}}</option>
                          }
                        </select>
                      </td>
                      <td>
                        <select class='form-control' (change)='this.changeVehicleArea($event)'>
                          <option value='-1'>Select a Vehicle Area</option>
                          @for (item of this.checkAreas; track item) {
                            <option [value]='item.id'>{{ item.name }}</option>
                          }
                        </select>
                      </td>
                      <td>
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" [id]="'newvor-' + t" [(ngModel)]='this.newCheck.isVor'>
                          @if (this.newCheck.isVor) {
                            <label class="custom-control-label" [attr.for]="'newvor-' + t">Failure triggers VOR</label>
                          }
                          @if (!this.newCheck.isVor) {
                            <label class="custom-control-label" [attr.for]="'newvor-' + t">Failure is not VOR</label>
                          }
                        </div>
                      </td>
                      <td>
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" [id]="'newactive-' + t" [(ngModel)]='this.newCheck.active'>
                          @if (this.newCheck.active) {
                            <label class="custom-control-label" [attr.for]="'newactive-' + t">Shows in App</label>
                          }
                          @if (!this.newCheck.active) {
                            <label class="custom-control-label" [attr.for]="'newactive-' + t">Hidden in App</label>
                          }
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan='6'>
                        <span class='btn-group'>
                          <button class='btn btn-success' (click)='saveCheck(vehicleType.vehicleTypeId)'>Save</button>
                          <button class='btn btn-danger' (click)='cancelCheck(vehicleType.vehicleTypeId)'>Cancel</button>
                        </span>
                      </td>
                    </tr>
                  }
                  <tr>
                    <td colspan='6'>
                      @if (!disableButtons) {
                        <button class='btn btn-secondary' (click)='addRow(vehicleType.vehicleTypeId)'><i class="fas fa-plus"></i> New</button>
                      }
                      @if (disableButtons) {
                        <button class='btn btn-secondary' disabled><i class="fas fa-plus"></i> New</button>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </app-tab>
          }
        </app-tabs>
      </div>
    </div>
  </div>
</div>
